export const Badge = ({
  color = "blue",
  children,
  onClick,
  className = "",
}) => {
  const map = {
    blue: "bg-blue-50 text-blue-700 border-blue-200",
    green: "bg-emerald-50 text-emerald-700 border-emerald-200",
    red: "bg-rose-50 text-rose-700 border-rose-200",
    yellow: "bg-amber-50 text-amber-700 border-amber-200",
    gray: "bg-slate-100 text-slate-700 border-slate-200",
  };

  return (
    <span
      onClick={onClick}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border cursor-pointer ${map[color]} ${className}`}
    >
      {children}
    </span>
  );
};


// export const Badge = ({ color = "blue", children }) => {
//   const map = {
//     blue: "bg-blue-50 text-blue-700 border-blue-200",
//     green: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     red: "bg-rose-50 text-rose-700 border-rose-200",
//     yellow: "bg-amber-50 text-amber-700 border-amber-200",
//     gray: "bg-slate-100 text-slate-700 border-slate-200",
//   };

//   return (
//     <span
//       className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border ${
//         map[color]
//       }`}
//     >
//       {children}
//     </span>
//   );
// };